import { render, staticRenderFns } from "./TagAgents.vue?vue&type=template&id=d9a661a6"
import script from "./TagAgents.vue?vue&type=script&setup=true&lang=js"
export * from "./TagAgents.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports